import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  .MuiLinearProgress-root {
    height: 2px;
    background-color: #e3f2fd;
  }
  .MuiLinearProgress-bar {
    background-color: #1565c0;
  }
`;
